(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["el-home-community"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(scope=document){scope.querySelectorAll('.elvc').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const track=root.querySelector('.elvc-track'),range=root.querySelector('input[type=range]');let sliding=false;function sync(){if(!sliding){const max=track.scrollWidth-track.clientWidth;range.value=max?Math.round(track.scrollLeft/max*1000):0;range.disabled=max<1;}}range.addEventListener('input',()=>{sliding=true;track.scrollLeft=Number(range.value)/1000*(track.scrollWidth-track.clientWidth);sliding=false;});track.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(track);let startX=0,startLeft=0,dragging=false,moved=false;track.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('video')?.controls)return;startX=e.clientX;startLeft=track.scrollLeft;dragging=true;moved=false;});window.addEventListener('pointermove',e=>{if(!dragging)return;const dx=e.clientX-startX;if(Math.abs(dx)>6){moved=true;track.classList.add('is-dragging');track.scrollLeft=startLeft-dx;e.preventDefault();}},{passive:false});window.addEventListener('pointerup',()=>{dragging=false;track.classList.remove('is-dragging');setTimeout(()=>moved=false,0);});track.addEventListener('click',e=>{if(moved){e.preventDefault();e.stopPropagation();}},true);root.querySelectorAll('.elvc-card').forEach(card=>{const video=card.querySelector('video'),play=card.querySelector('.elvc-play'),time=card.querySelector('.elvc-duration'),status=card.querySelector('.elvc-status');function reset(){play.hidden=false;card.classList.remove('is-playing');}function duration(){if(Number.isFinite(video.duration)){const value=Math.floor(video.duration);time.textContent=String(Math.floor(value/60)).padStart(2,'0')+':'+String(value%60).padStart(2,'0');}}video.addEventListener('loadedmetadata',duration);video.addEventListener('play',()=>{root.querySelectorAll('video').forEach(v=>{if(v!==video)v.pause();});play.hidden=true;status.hidden=true;video.controls=true;card.classList.add('is-playing');});video.addEventListener('pause',()=>card.classList.remove('is-playing'));video.addEventListener('ended',()=>{video.controls=false;reset();});video.addEventListener('error',()=>{status.hidden=false;reset();});play.addEventListener('click',()=>{if(moved)return;status.hidden=true;video.play().catch(()=>{status.hidden=false;reset();});});});document.addEventListener('visibilitychange',()=>{if(document.hidden)root.querySelectorAll('video').forEach(v=>v.pause());});sync();});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();document.addEventListener('shopify:section:load',e=>init(e.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["el-reviews"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(){document.querySelectorAll('.er-section').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const grid=root.querySelector('[data-er-grid]'),cards=[...grid.querySelectorAll('.er-card')];root.querySelector('.er-sort select').onchange=e=>{const value=e.target.value;cards.sort((a,b)=>value==='featured'?Number(a.dataset.erOrder)-Number(b.dataset.erOrder):(value==='newest'?-1:1)*(Number(a.dataset.erDate)-Number(b.dataset.erDate)));cards.forEach(c=>grid.append(c));};const filter=root.querySelector('.er-filter'),sort=root.querySelector('.er-sort');filter.onclick=()=>{sort.hidden=!sort.hidden;filter.setAttribute('aria-expanded',String(!sort.hidden));};root.querySelectorAll('[data-er-open]').forEach(b=>b.onclick=()=>document.getElementById(b.dataset.erOpen)?.showModal());root.querySelectorAll('dialog').forEach(d=>{d.querySelector('[data-er-close]').onclick=()=>d.close();d.onclick=e=>{if(e.target===d)d.close();};});if(root.querySelector('.er-write-dialog [role="status"]'))root.querySelector('.er-write-dialog').showModal();});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
